<template>
  <div :class="{'pricing-section': true, 'col-lg-12': promotion_message, 'col-lg-6': !promotion_message}">
  <div class="pricing-section">
    <div class="price">
      <template v-if="isonsaleproduct == '1'">
        <span v-if="lngid == '7'" style="font-size: 1.8rem;">RRP</span>
        <span class="full-price" v-html="productpricelevel1withcurrency"></span>
        <p class="sale-price" v-html="productpricewithcurrency"></p>
      </template>
      <template v-else>
        <span v-html="productpricewithcurrency"></span>
      </template>

    </div>
    <template
      v-if="isonsaleproduct == '1' && ['LC2112', 'GU2112', 'AT2112VA', 'AT2112RB', '45111B', '45108B', '41103', 'RVP26', 'RVPT527', '43250', '43251', 'RTD25L', 'RBCA010', 'RF1', 'RTD35L', '43119B', '43120B', 'RTS527', 'RLKVFH', 'RTS502', 'RTS551'].includes(stockcode)">
      <div class="rrp">
        (RRP inc GST)
      </div>
    </template>
    <template v-else>
      <div class="rrp" v-html="normalpricinglabel">
      </div>
    </template>
  </div>
  <div class="promo-section">
    <div class="col-lg-12">
      <div class="promotion-msg">
        <p class="promo-text"><span v-html="promotion_message"></span></p>
      </div>
    </div>
  </div>
</div>
</template>

<script>

export default {
name: "header-pricing",
data() {
  return {
  };
},
props: {
  promotion_message: {
    type: String
  },
  lngid: {
    type: String
  },
  stockcode: {
    type: String
  },
  isonsaleproduct: {
    type: String
  },
  productpricelevel1withcurrency: {
    type: String
  },
  productpricewithcurrency: {
    type: String
  },
  normalpricinglabel: {
    type: String
  },
  sitekey: {
    type: String
  },
  netsuite_url: {
    type: String
  },
  netsuite_parent_id: {
    type: String,
  },
  netsuite_id: {
    type: String
  },
  package_components: {
    type: String
  },
  parent_status: {
    type: String
  },
  parent_isinstock: {
    type: String
  },
  parent_isbackorderable: {
    type: String
  },
  childactivestatus: {
    type: String
  },
  childbackorderablestatus: {
    type: String
  },
  product_id: {
    type: String
  },
  components: {
    type: Array
  },
  is_stock_waitlist_active: {
    type: String
  },
  is_spare_part_enabled: {
    type: String
  },
  is_always_in_stock: {
    type: String
  },
  label_stock_availability: {
    type: String,
    default: "Stock Availability"
  },
  label_in_stock: {
    type: String,
    default: "In Stock"
  },
  label_available_for_backorder: {
    type: String,
    default: "Available for Backorder"
  },
  label_out_of_stock: {
    type: String,
    default: "Out of Stock – Call for info"
  },
  label_expand: {
    type: String,
    default: "Expand for dealer pricing"
  },
  label_product_price_breakdown: {
    type: String,
    default: "Product Price Breakdown"
  },
  label_estimated: {
    type: String,
    default: "Prices are estimated, further discounts may apply at checkout."
  },
},
mounted() { },
methods: {}
};
</script>

<style lang="scss" scoped>
.promotion-msg{
.promo-text{
  margin-left: -15px;
}
}
</style>

